import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { MediaPlayer } from "../../shared";
import ViewOptions from "../Questions/ViewOptions";
import Coursedetail from "./Coursedetail";
import Exercise from "../Questions/Exercise";
import { useLogin } from "../../../context/LoginContext";
import { useLesson } from "../../../context/LessonContext";
import { shuffleArray, lmsConfig } from '../../../utils/utils';
const ViewLesson = () => {
  const { getnextLesson, lessons, activeIdx, TrackLessonView, lastPosition } = useLesson();
  // console.log("🚀 krishna  ~  activeIdx, lastPosition :",  activeIdx, lastPosition );

  const { user } = useLogin();
  const [type, setType] = useState('');
  const [lesson, setLesson] = useState([]);
  useEffect(() => {
    if (lessons?.length > 0) {
      setType(lessons[activeIdx]?.type);
      if (lessons[activeIdx]?.type === 'quiz' && user.selectedRole === 'viewer') {
        const questions = lessons[activeIdx]?.refDetails?.questions || [];
        // const shuffledOption = questions.map(q => ({
        //   ...q,
        //   options: shuffleArray(q.options || [])
        // }));
        const shuffledQuestions = shuffleArray(questions);

        setLesson({ ...lessons[activeIdx], refDetails: { ...lessons[activeIdx]?.refDetails, questions: shuffledQuestions } });
      } else {
        setLesson(lessons[activeIdx]);
      }
    }
  }, [lessons, activeIdx]);

  // Memoize lesson?.refDetails to avoid unnecessary rerenders
  const memoizedLessonDetails = useMemo(() => lesson?.refDetails, [lesson?.refDetails]);

  return (
    <Container>
      <Row>
        {type === "video" ?
          <Col xs={12} className="course-video-view" >
            <MediaPlayer vidUrl={lesson?.refDetails?._id} width={'100%'} height={'460'} onEnded={getnextLesson} TrackLessonView={TrackLessonView} lastPosition={lastPosition} />
          </Col>
          : type === "quiz" ?
            <Col xs={12} >
              <Row className="mb-3" style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Col md={10}><h4>{lesson?.refDetails?.title}</h4></Col>
                <Col md={2}><h6>Total Question : {user.selectedRole === 'viewer' ? lesson?.refDetails?.questions?.length > lmsConfig.totalQuestionToShow ? lmsConfig.totalQuestionToShow : lesson?.refDetails?.questions?.length : lesson?.refDetails?.questions?.length}</h6></Col>
              </Row>
              <Row className='p-0 border mb-3 question-list-container'>
                {user.selectedRole === 'viewer' ? <Exercise lesson={lesson} />
                  :
                  lesson ? lesson?.refDetails?.questions?.map((question, index) => {
                    return <Col lg={12} key={index} className='question-preview-listing'>
                      <ViewOptions question={question} qnumber={1 + index} />
                    </Col>
                  }) : <p>No Quiz found</p>
                }
              </Row>
            </Col>
            : null
        }
        <Coursedetail lesson={memoizedLessonDetails} />
      </Row>
    </Container>
  );
};

export default ViewLesson;
